import { render, staticRenderFns } from "./myAssetsDetail.vue?vue&type=template&id=4c1c8aaf&scoped=true"
import script from "./myAssetsDetail.vue?vue&type=script&lang=js"
export * from "./myAssetsDetail.vue?vue&type=script&lang=js"
import style0 from "./myAssetsDetail.vue?vue&type=style&index=0&id=4c1c8aaf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1c8aaf",
  null
  
)

export default component.exports